export default __webpack_public_path__ + "static/images/plugin-wpforms.png?9d8e6c074e7d6430812042d63135a822";